module.exports = __webpack_public_path__ + "img/Reviews and Ratings_old.1c5a66fc.svg";